import useRelanceRDO from "./useRelanceRDO";
import ReactTooltip from "react-tooltip";

const RelanceRDOButton = ({ allocataireId }) => {
  const {
    peutEnvoyer,
    erreur,
    isLoading,
    isSending,
    envoyerRelance,
    envoyeData,
  } = useRelanceRDO(allocataireId);

  // Si l'invitation a été envoyée, afficher le message de confirmation
  if (envoyeData) {
    return (
      <div
        className="alert alert-success d-flex align-items-center"
        role="alert"
      >
        <i className="fa fa-check-circle mr-2" />
        <div>
          <strong>Invitation en cours d'envoi</strong>
          <br />
          <small>
            Numéro de lot :{" "}
            <a
              href={`/invite-rdo?tab=list&numeroLot=${envoyeData.numeroLot}`}
              className="alert-link font-weight-bold"
              target="_blank"
              rel="noopener noreferrer"
            >
              {envoyeData.numeroLot}
            </a>
          </small>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <button className="btn btn-secondary btn-sm" disabled>
        <i className="fa fa-spinner fa-spin mr-2" />
        Vérification...
      </button>
    );
  }

  const buttonId = `relance-rdo-btn-${allocataireId}`;

  return (
    <>
      <button
        id={buttonId}
        className={`btn btn-sm ${peutEnvoyer ? "btn-info" : "btn-secondary"}`}
        onClick={envoyerRelance}
        disabled={!peutEnvoyer || isSending}
        data-tip={!peutEnvoyer && erreur ? erreur : ""}
        data-for={buttonId}
      >
        {isSending ? (
          <>
            <i className="fa fa-spinner fa-spin mr-2" />
            Envoi en cours...
          </>
        ) : (
          <>
            <i className="fa fa-paper-plane mr-2" />
            Envoyer invitation RDO
          </>
        )}
      </button>
      {!peutEnvoyer && erreur && (
        <ReactTooltip id={buttonId} place="right" effect="solid" />
      )}
    </>
  );
};

export default RelanceRDOButton;
